import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GalleryItemsLoadMoreComponent } from '@app/entities/images/components/gallery-items-load-more/gallery-items-load-more.component';
import { ImagePreview } from '@app/entities/images/interfaces/image-preview';
import { GalleryComponent } from '@app/layout/gallery/gallery.component';
import { ImageSelectors, LoadRelatedImages } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-item-gallery',
  templateUrl: './item-gallery.component.html',
  styleUrls: ['./item-gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GalleryComponent, GalleryItemsLoadMoreComponent, AsyncPipe],
})
export class ItemGalleryComponent {
  constructor(private store: Store) {}

  protected relatedImages$: Observable<ImagePreview[]> = this.store.select(
    ImageSelectors.relatedImages,
  ) as Observable<ImagePreview[]>;

  protected hasMoreResults$: Observable<boolean> = this.store.select(
    ImageSelectors.hasMoreResults,
  );

  protected onLoadMore(): void {
    this.store.dispatch(new LoadRelatedImages());
  }
}
